export default "__VITE_ASSET__DnkDMB38__"